import { render } from "./communitySection.vue?vue&type=template&id=0090351c"
import script from "./communitySection.vue?vue&type=script&lang=js"
export * from "./communitySection.vue?vue&type=script&lang=js"

import "./communitySection.vue?vue&type=style&index=0&id=0090351c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__